import { useSelector, useDispatch } from "react-redux"
import { Form, Image, Button, Space, Row, Col, Typography} from "antd"
import { StoreInput } from '../../components'
import { actionsApi } from "../../shared"
import "./index.css"
const {Title}= Typography

const Login = () => {

    const appDispatcher = useDispatch()
    const [form] = Form.useForm()
    const { loading } = useSelector(state => state?.login)
    const login = () => {
        appDispatcher(actionsApi?.login(form.getFieldsValue(['email', 'password'])))
    }
    return (
        <div 
            className='login-form-cover'
            >
            <div className="center">
                <Row className="login-form border-grey">
                    <Col md={12} sm={24} xs={24}>
                        <Space 
                            direction='vertical' 
                            className='py-5 px-4 width-100'
                            size={15}
                            >
                            <div>
                                <div className="justify-center">
                                    <Image
                                        src={"./assets/logo-b.png"}
                                        alt='Store App Admin Panel'
                                        preview= {false}
                                        width={'120px'}
                                    />
                                </div>
                                <Title 
                                    level={5} 
                                    className="my-0 text-center brand-color"
                                    >
                                    Login to access your dashboard
                                </Title>
                            </div>
                            <Form
                                form={form}
                                layout="vertical"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={login}
                                style={{ width: '100%' }}
                            >
                                <Row>
                                    <Col span={24}>
                                        <StoreInput
                                            name="email"
                                            label="Email"
                                            required
                                            message='please enter email'
                                            size='large'
                                            value={form.getFieldValue('email') || ''}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <StoreInput
                                            name="password"
                                            type='password'
                                            label="Password"
                                            size='large'
                                            required
                                            message='please enter password'
                                            value={form.getFieldValue('password') || ''}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Button 
                                            type="primary"
                                            htmlType="submit" 
                                            size="large"
                                            block
                                            loading={loading}
                                            >
                                            Login
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Space>
                    </Col>
                    <Col 
                        md={12} sm={0} xs={0}
                        className="bg-gray2 center"
                    >
                        <Image 
                            src="/assets/login-right.png" 
                            preview={false} 
                        />
                    </Col>
                </Row>
            </div>
        </div>
    )
}
export {Login}